<template>
  <div class="product-options__other-options">
    <div v-if="!isDropdownView" v-for="(optionValue, index) in group" :key="index" ref="optionItems">
      <div
        v-if="['Inseam', 'Outseam'].includes(optionName) && additionalPropertyOptions.length"
        :class="[
          'product-options__item',
          { selected: optionValue.value?.trim() === selectedOptions[optionName]?.trim() },
          { 'is--number-type': isNumber(optionValue.value) },
        ]"
      >
        <a
          :href="seamHandle(optionValue.value, selectedOptions[optionName])"
          class="product-options__item-name"
          :aria-label="`option ${optionValue.value} for ${optionName}`"
        >
          {{ optionValue.value }}
        </a>
      </div>

      <button
        v-else
        :class="[
          'product-options__item',
          { selected: optionValue.value?.trim() === selectedOptions[optionName]?.trim() },
          { 'is--onesize': optionValue.value.toLowerCase() === 'one size' },
          { 'is--number-type': isNumber(optionValue.value) },
          { 'is--size': optionName === 'Size' },
        ]"
        data-stio-gtm-id="PDP: Option"
        :data-available="optionValue.available"
        :disabled="hideUnavailableOption ? !optionValue.available : false"
        @click="() => updateSelection(optionName, optionValue.value, optionValue)"
        :aria-disabled="!optionValue.available"
        :aria-pressed="optionValue.value?.trim() === selectedOptions[optionName]?.trim()"
        :aria-label="`option: ${optionName} ${getModifiedOptionName(optionName, optionValue.value)}`"
      >
        <span class="product-options__item-name">
          {{ getModifiedOptionName(optionName, optionValue.value) }}
        </span>

        <!-- Strike line if not available -->
        <span
          v-if="!optionValue.available"
          class="strike-line"
          :style="{
            width: calculateDiagonal(index) + 'px',
            transform: 'translate(-50%, -50%) rotate(-45deg)',
          }"
        ></span>
      </button>
    </div>

    <div v-else>
      <CustomSelect
        :options="group.map((grp) => grp.value)"
        :callbackProps="{ optionName, value: group }"
        :enableBodyOverflow="false"
        :enablePrefixOnOption="false"
        :enableSuffixOnOption="false"
        optionPrefix="AMOUNT"
        placeholder="AMOUNT Select an option"
        :selectedValueProp="selectedOptions[optionName]"
        :onDropdownSelect="handleOptionChangeOnDropdown"
      />
    </div>
  </div>
</template>

<script setup>
  import { ref, toRefs } from 'vue';
  import CustomSelect from '../global/custom-select.vue';

  const props = defineProps({
    group: Array,
    optionName: String,
    selectedOptions: Object,
    hideUnavailableOption: Boolean,
    additionalPropertyOptions: Array,
    updateSelection: Function,
    getModifiedOptionName: Function,
    seamHandle: Function,
    isDropdownView: Boolean,
  });

  const { optionName } = toRefs(props);

  /**
   * Check if the value is a number
   * @param {String} value
   * @returns {Boolean}
   */
  const isNumber = (value) => !isNaN(Number(value));

  const optionItems = ref([]);

  const handleOptionChangeOnDropdown = (value) => {
    props.updateSelection(optionName.value, value);
  }

  const calculateDiagonal = (index) => {
    const item = optionItems.value[index]?.querySelector('button');
    if (!item) return 0;
    const width = item.offsetWidth;
    const height = item.offsetHeight;
    return Math.sqrt(width * width + height * height);
  };

  const calculateAngle = (index) => {
    const item = optionItems.value[index]?.querySelector('button');
    if (!item) return -45; // default
    const width = item.offsetWidth;
    const height = item.offsetHeight;
    const angleRad = Math.atan(height / width); // in radians
    const angleDeg = -(angleRad * (180 / Math.PI)); // convert to degrees and negative
    return angleDeg.toFixed(2);
  };
</script>
